/* @flow */
import ApiModel, { type Config as Options, type Interceptor } from './ApiModel';

export type { Options, Interceptor };

export default class RequestAwareApiModel extends ApiModel {
    constructor(options: Options) {
        super(options);
        this.requestMap = {
            fetch: {},
            post: {},
            head: {},
            put: {},
            delete: {},
            patch: {}
        };
    }

    getSavedPromise(type, params) {
        const serializedParams = JSON.stringify(params);
        const requestsForType = this.requestMap[type];
        const savedPromise = requestsForType[serializedParams];
        return savedPromise;
    }

    savePromise(type, params, promise) {
        const serializedParams = JSON.stringify(params);
        const requestsForType = this.requestMap[type];
        requestsForType[serializedParams] = promise;
        this.deleteWhenDone(type, params, promise);
    }

    process(args, type, modelMethod) {
        const savedPromise = this.getSavedPromise(type, [...args]);
        if (savedPromise) {
            return Promise.resolve(savedPromise);
        }
        const newPromise = modelMethod();
        this.savePromise(type, [...args], newPromise);
        return newPromise;
    }

    deleteWhenDone(type, params, promise) {
        Promise.resolve(promise)
            .then(() => {
                this.deletePromise(type, params);
            })
            .catch(() => {
                this.deletePromise(type, params);
            });
    }

    deletePromise(type, params) {
        const serializedParams = JSON.stringify(params);
        const requestsForType = this.requestMap[type];
        delete requestsForType[serializedParams];
    }

    fetch(...args) {
        return this.process(args, 'fetch', () => super.fetch(...args));
    }

    delete(...args) {
        return this.process(args, 'delete', () => super.delete(...args));
    }

    head(...args) {
        return this.process(args, 'head', () => super.head(...args));
    }

    post(...args) {
        return this.process(args, 'post', () => super.post(...args));
    }

    put(...args) {
        return this.process(args, 'put', () => super.put(...args));
    }

    patch(...args) {
        return this.process(args, 'patch', () => super.patch(...args));
    }
}
